import React from 'react';
import Switch from '../../../../shared/switch';
import TableActions from '../../../../shared/table/table-actions';


const AiModelsTable = ({
    rows,
    loading,
    paginationData,
    paginationState,
    setPaginationState,
    onChangeStatus,
    onDeleteItem,
    onClickModal
}: {
    rows?: any;
    loading?: boolean;
    paginationData?: any;
    paginationState?: any;
    setPaginationState?: any;
    onClickModal: (data: any) => void;
    onDeleteItem: (data: any) => void;
    onChangeStatus: (id: string, enabled: boolean) => void;
}) => {

    return (
        <div className=''>
            <div className='overflow-x-auto border border-1 !rounded-xl dark:border-borderColor-darkMode'>
                <table className='min-w-full bg-white dark:bg-black dark:text-primary-darkMode min-h-[200px]'>
                    <thead className='bg-white dark:bg-black text-left text-sm font-medium text-black dark:text-primary-darkMode rounded-xl'>
                        <tr>
                            <th className='px-4 py-3'>ID</th>
                            <th className='px-4 py-3'>Name</th>
                            <th className='px-4 py-3'>Icon</th>
                            <th className='px-4 py-3'>API URL</th>
                            <th className='px-4 py-3'>API Key</th>
                            <th className='px-4 py-3'>Status(Enabled/Disabled)</th>
                            <th className='px-4 py-3'>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading &&
                            Array.from({ length: 5 }).map((_, i) => (
                                <tr key={`skeleton-${i}`} className='animate-pulse'>
                                    <td className='px-4 py-4'>
                                        <div className='h-4 bg-gray-200 dark:bg-gray-700 rounded w-3/4'></div>
                                    </td>
                                    <td className='px-4 py-4'>
                                        <div className='h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/3'></div>
                                    </td>
                                    <td className='px-4 py-4'>
                                        <div className='h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/2'></div>
                                    </td>
                                    <td className='px-4 py-4'>
                                        <div className='h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/2'></div>
                                    </td>
                                    <td className='px-4 py-4'>
                                        <div className='h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/2'></div>
                                    </td>
                                    <td className='px-4 py-4'>
                                        <div className='h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/2'></div>
                                    </td>
                                    <td className='px-4 py-4'>
                                        <div className='h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/2'></div>
                                    </td>
                                </tr>
                            ))}
                        {!loading && (!rows || rows.length === 0) && (
                            <tr>
                                <td colSpan={7} className='px-4 py-6 text-center text-gray-500 dark:text-primary-dark'>
                                    No data currently available
                                </td>
                            </tr>
                        )}
                        {(!loading && rows?.length > 0) && rows?.map((row: any) => (
                            <tr key={row._id} className='hover:bg-gray-50 dark:hover:bg-bgColor-darkMode text-sm'>
                                <td className={`px-4 py-4`}>{row?._id}</td>
                                <td className={`px-4 py-4`}>{row?.name}</td>
                                <td className={`px-4 py-4`}>
                                    {row?.logoUrl &&
                                        <img src={row?.logoUrl} className='w-[25px] object-contain' />
                                    }
                                </td>
                                <td className={`px-4 py-4`}>{row?.apiUrl || '--'}</td>
                                <td className={`px-4 py-4`}>{row?.apiKey || '--'}</td>
                                <td className={`px-4 py-4`}>
                                    <Switch
                                        checked={row?.enabled}
                                        onToggleSwitch={() => onChangeStatus(row?._id || '', row?.enabled)}
                                    />
                                </td>
                                <td className={`px-4 py-4`}>
                                    <TableActions
                                        containerStyle='!mt-[-10px] !mr-[-30px] !rounded-sm dark:bg-gray-800'>
                                        <div
                                            onClick={() => onClickModal(row)}
                                            className='bg-gray-100 dark:bg-gray-800 shadow-xl px-5 py-2 cursor-pointer hover:opacity-70'>
                                            <p className='dark:text-primary-dark'>Edit Model</p>
                                        </div>
                                        <div
                                            onClick={() => onDeleteItem?.(row)}
                                            className='bg-gray-100 dark:bg-gray-800 shadow-xl px-5 py-2 cursor-pointer hover:opacity-70'>
                                            <p className='text-red-600'>Delete Model</p>
                                        </div>

                                    </TableActions>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            {paginationData &&
                (() => {
                    const currentPage = paginationData.number;
                    const totalPages = paginationData.totalPages;

                    const getPageList = () => {
                        const pageList: (number | string)[] = [];

                        if (totalPages <= 7) {
                            for (let i = 1; i <= totalPages; i++) {
                                pageList.push(i);
                            }
                        } else {
                            pageList.push(1);

                            if (currentPage > 3) {
                                pageList.push('...');
                            }

                            const start = Math.max(2, currentPage - 1);
                            const end = Math.min(totalPages - 1, currentPage + 1);

                            for (let i = start; i <= end; i++) {
                                pageList.push(i);
                            }

                            if (currentPage < totalPages - 2) {
                                pageList.push('...');
                            }

                            pageList.push(totalPages);
                        }

                        return pageList;
                    };

                    return (
                        <div className='flex justify-between items-center text-sm text-[#8F8F8F] dark:text-primary-darkMode px-5 py-2 mt-1 border-t border-[#DCDCDD]'>
                            {/* <div>
                                {paginationData.totalElements > 0 && (
                                    <span>
                                        {1 + ((currentPage - 1) * paginationData.size)}–
                                        {Math.min(currentPage * paginationData.size, paginationData.totalElements)} of {paginationData.totalElements} items
                                    </span>
                                )}
                            </div> */}
                            <div className='flex items-center gap-2'>
                                <button
                                    disabled={currentPage <= 1}
                                    onClick={() =>
                                        setPaginationState?.({ ...paginationState, pageNumber: currentPage - 1 })
                                    }
                                    className='hover:bg-gray-300 dark:hover:bg-black cursor-pointer px-2 py-1 rounded disabled:opacity-50'
                                >
                                    ◀
                                </button>

                                {getPageList().map((item, idx) => {
                                    if (typeof item === 'string') {
                                        return <span key={idx} className='px-2'>...</span>;
                                    }
                                    return (
                                        <button
                                            key={idx}
                                            onClick={() => setPaginationState?.({ ...paginationState, pageNumber: item })}
                                            className={`px-3 py-1 rounded transition-colors duration-200 ${item === currentPage ? 'bg-gray-400 text-white dark:bg-white dark:text-black' : 'hover:bg-gray-300 dark:hover:bg-black'}`}
                                        >
                                            {item}
                                        </button>
                                    );
                                })}

                                <button
                                    disabled={!paginationData?.hasNextPage}
                                    onClick={() =>
                                        setPaginationState?.({ ...paginationState, pageNumber: currentPage + 1 })
                                    }
                                    className='hover:bg-gray-300 dark:hover:bg-black cursor-pointer px-2 py-1 rounded disabled:opacity-50'
                                >
                                    ▶
                                </button>
                            </div>
                        </div>
                    );
                })()
            }
        </div>
    );
};

export default AiModelsTable;